import styled from 'styled-components';

import { S26 } from 'atoms/icons/S26';
import { SorareLogo } from 'atoms/icons/SorareLogo';
import { Horizontal } from 'atoms/layout/flex';
import { unitMapping } from 'lib/style';
import { tabletAndAbove } from 'style/mediaQuery';
import { Color, HexColorOnly } from 'style/types';

const StyledSorareLogo = styled(SorareLogo)`
  .large & {
    @container ${tabletAndAbove} {
      height: calc(4.5 * var(--unit));
      width: calc(30 * var(--unit));
    }
  }

  .small & {
    height: var(--double-unit);
    width: calc(13 * var(--unit));
  }
`;

type Props = {
  gap?: 'small' | 'large';
  iconSize?: keyof typeof unitMapping;
  size?: 'small' | 'medium' | 'large';
  color?: Color | HexColorOnly;
};

export const NewSeasonLogo = ({
  gap = 'large',
  size = 'medium',
  iconSize = 7,
  color = 'var(--c-white)',
}: Props) => {
  return (
    <Horizontal gap={gap === 'small' ? 1 : 2} className={gap}>
      <StyledSorareLogo size={size} color={color} />
      <S26 size={iconSize} color={color} />
    </Horizontal>
  );
};
